import type { InternalHost } from '@xing-com/crate-xinglet';
import { useHost } from '@xing-com/crate-xinglet';

export const useDeviceInfo = () => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const host = useHost() as InternalHost;
  return {
    isWebview: host.config.isWebview ?? false,
    android: host.config.deviceInfo?.isAndroid ?? false,
    mobileProtocol: host.config.deviceInfo?.mobileProtocol,
    profileUrlMobile: host.config.deviceInfo?.profileUrlMobile,
  };
};
